export enum EComplaintsTagType {
  CASES = 'complaintCases',
  CASE = 'complaintCase',
}
